import React, { FormEvent, useContext, useState, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import {RegistryWidgetsType, RJSFSchema, UiSchema} from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { WorkflowNode, ToolOption, Workflow, Agent } from "../../../../types/workflow";
import { useReactFlow, applyNodeChanges, ReactFlowInstance } from "@xyflow/react";
import { Tool } from "../../../../types/entities";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { processIfNodeDelete, formSchema, processNodeFormSubmit, nodeDescription } from "./functions/workflow-switch-node-configuration";
import { PromptTemplateFormWidget } from "./components/PromptTemplateFormWidget";
import { LLMModelWidget } from "./components/LLMModelWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import {
    Button
} from '@mui/material';

export const WorkflowSwitchNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();


    function handleCloseDialog(): void {
        context.toggleShowSwitchModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode(): void {
        processIfNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }

    const uiSchema: UiSchema = {
        'data_store': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'data_to_loop',
                    'messages',
                    'scraper_pending'
                ]
            }
        },
        'expected_value': {
            'ui:widget': 'textarea'
        },
        'system_prompt': {
            'ui:widget': 'PromptTemplateFormWidget'
        },
        'action_prompt': {
            'ui:widget': 'PromptTemplateFormWidget'
        },
        'llm': {
            'ui:widget': 'LLMModelWidget'
        },
        'ui:order': [
            'data_store',
            'input_key',
            'if_type',
            'allOf',
            'system_prompt',
            'action_prompt',
            'data_management',
            'conditions',
            'evaluation',
            'evaluation_value',
            'evaluation_key',
            'llm_temperature',
            'llm'
        ]
    }

    const widgets: RegistryWidgetsType = {
        PromptTemplateFormWidget: PromptTemplateFormWidget,
        LLMModelWidget: LLMModelWidget,
        NodeDataManagementWidget: NodeDataStoreSelectWidget
    }

    return (
        <DefaultFormDialog
            open={ context.showSwitchModal }
            title={ "Switch Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditSwitchNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-if-node-configure"
                formData={ (
                    context.activeEditSwitchNode !== undefined &&
                    context.activeEditSwitchNode.data !== undefined ?
                        context.activeEditSwitchNode.data : undefined
                ) }
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    { (context.activeEditSwitchNode ) &&
                        <Button
                            variant="contained"
                            color="error"
                            onClick={ deleteNode }
                            type="button">
                            <DeleteIcon />
                            <span>{ "Delete" }</span>
                        </Button>
                    }

                </div>
            </Form>
        </DefaultFormDialog>
    );
}